function getUrlParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    let results = regex.exec(url);

    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

const encryptSearchKeyList = [
    'md5hash',
    'timestamp',
];

/**
 * 获取 url 参数
 * @param url - url地址
 * @return {Object} url 参数 map
 */
export function getUrlParam(url) {
    try {
        let name;
        let value;
        let str = url.split('#')[0];
        let num = str.indexOf('?');
        if (num === -1) {
            return {};
        }
        str = str.substr(num + 1);
        let arr = str.split('&');
        let paramsObj = {};
        for (let i = 0; i < arr.length; i++) {
            num = arr[i].indexOf('=');
            if (num > 0) {
                name = arr[i].substring(0, num);
                value = arr[i].substr(num + 1);
                try {
                    paramsObj[name] = decodeURIComponent(value);
                }
                catch (e) {
                    paramsObj[name] = value;
                }
            }
        }
        return paramsObj;
    }
    catch (e) {
        return {};
    }
}

/**
 * 将对象转换为http body
 * @param  {Object} obj 要转换的对象，属性值应为字符串
 * @return {string}     http body
 */
function objToParam(obj) {
    let params = [];
    const sortedKeyList = Object.keys(obj).sort();
    for (let i = 0; i < sortedKeyList.length; i++) {
        let key = sortedKeyList[i];
        if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key]) {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
        }
    }
    return params.join('&');
}

/**
 * 将url search中加密的参数去掉，将剩余的search参数按字母排序
 * @param {string} url - 图片url
 * @return {string} 修改后的url
 */
function deleteEncryptSearchParamFromImgUrl(url) {
    const searchObj = getUrlParam(url);
    for (let i = 0; i < encryptSearchKeyList.length; i++) {
        delete searchObj[encryptSearchKeyList[i]];
    }
    let retUrl = url.split('?')[0];
    if (Object.keys(searchObj).length > 0) {
        retUrl = retUrl + '?' + objToParam(searchObj);
    }
    return retUrl;
}

/**
 * 清除url上的 订单相关参数 防止多次弹窗等
 * @param  {string} routeQuery router 里面的参数
 */
function clearPayParams(routeQuery) {
    if (!routeQuery) {
        return null;
    }
    let newQuery = JSON.parse(JSON.stringify(routeQuery)); // 深拷贝
    delete newQuery?.tspdOrderId;
    delete newQuery?.goods_type;
    delete newQuery?.pay_id;
    delete newQuery?.orderId;
    delete newQuery?.payResult;
    delete newQuery?.returnData;
    delete newQuery?.tpOrderId;
    return newQuery;
}

export {
    clearPayParams, deleteEncryptSearchParamFromImgUrl, getUrlParameterByName,
};
